import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IFailedPayload } from 'redux/types/Call.types';
import {
  IComplianceFilterRequest,
  IComplianceFilterResponse,
  IGetAgenciesRequest,
  IGetAgenciesResponse,
} from 'redux/types/compliance/Agency.types';

export interface AgencyState {
  error: IFailedPayload | null;
  loading: boolean;
  message: string;
  agencies: IGetAgenciesResponse | null;
  pincodeFilter: IComplianceFilterResponse | null;
  cityFilter: IComplianceFilterResponse | null;
  areaFilter: IComplianceFilterResponse | null;
  isSearching: boolean;
}
export const agencyInitialState: AgencyState = {
  error: null,
  loading: false,
  message: '',
  agencies: null,
  pincodeFilter: null,
  cityFilter: null,
  areaFilter: null,
  isSearching: false,
};
const agencySlice = createSlice({
  name: 'compliance/agency',
  initialState: agencyInitialState,
  reducers: {
    fetchMyAgencies: (state, action: PayloadAction<IGetAgenciesRequest>) => {
      state.loading = true;
      state.error = null;
    },
    fetchMyAgenciesSuccess: (
      state,
      action: PayloadAction<IGetAgenciesResponse>
    ) => {
      state.loading = false;
      state.agencies = action.payload;
    },
    fetchMyAgenciesFailure: (state, action: PayloadAction<IFailedPayload>) => {
      state.error = action.payload;
      state.loading = false;
    },
    fetchPincodeFilter: (
      state,
      action: PayloadAction<IComplianceFilterRequest>
    ) => {
      state.loading = true;
    },
    fetchPincodeFilterSuccess: (
      state,
      action: PayloadAction<IComplianceFilterResponse>
    ) => {
      state.loading = false;
      state.pincodeFilter = action.payload;
    },
    fetchPincodeFilterFailure: (
      state,
      action: PayloadAction<IFailedPayload>
    ) => {
      state.error = action.payload;
      state.loading = false;
    },

    fetchCityFilter: (
      state,
      action: PayloadAction<IComplianceFilterRequest>
    ) => {
      state.loading = true;
    },
    fetchCityFilterSuccess: (
      state,
      action: PayloadAction<IComplianceFilterResponse>
    ) => {
      state.loading = false;
      state.cityFilter = action.payload;
    },
    fetchCityFilterFailure: (state, action: PayloadAction<IFailedPayload>) => {
      state.error = action.payload;
      state.loading = false;
    },

    fetchAreaFilter: (
      state,
      action: PayloadAction<IComplianceFilterRequest>
    ) => {
      state.loading = true;
    },
    fetchAreaFilterSuccess: (
      state,
      action: PayloadAction<IComplianceFilterResponse>
    ) => {
      state.loading = false;
      state.areaFilter = action.payload;
    },
    fetchAreaFilterFailure: (state, action: PayloadAction<IFailedPayload>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});
export const {
  fetchMyAgencies,
  fetchMyAgenciesSuccess,
  fetchMyAgenciesFailure,
  fetchPincodeFilter,
  fetchPincodeFilterSuccess,
  fetchPincodeFilterFailure,
  fetchCityFilter,
  fetchCityFilterSuccess,
  fetchCityFilterFailure,
  fetchAreaFilter,
  fetchAreaFilterSuccess,
  fetchAreaFilterFailure,
} = agencySlice.actions;
export default agencySlice.reducer;
